export const sceneItems = (solutionItems, catalog) => {

    const sceneItems = []

    solutionItems.forEach(item => {

        const sku = item.parentSku
        const variantSku = item.sku
        const product = catalog.getParentProduct(sku)

        if(product) {
            const variant = (variantSku && product.variants[variantSku])
                ? product.variants[variantSku]
                : Object.values(product.variants)[0]

            sceneItems.push({
                id: item.id,
                elements: JSON.parse(JSON.stringify(item.elements)),
                threeDModel: variant.threeDModel
            })
        }
    })

    return sceneItems
}

export const resetCamera = () => {
    /** reset 2d/3d canvas view properties */
    localStorage.removeItem('camerapos');
    localStorage.removeItem('camerazoom');
}